module.exports = __webpack_public_path__ + "img/bind-jd-2.ffc3999f.png";